const columns: TableColumn[] = [
  {
    Header: `Type`,
    accessor: `jobType`,
    dbKey: `jobType`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: false
  },
  {
    Header: `Status`,
    accessor: `status`,
    dbKey: `status`,
    isString: false,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: false
  },
  {
    Header: `Created`,
    accessor: `createdAt`,
    dbKey: `createdAt`,
    isString: false,
    isNumeric: false,
    isDate: true,
    isBool: false,
    isSortable: false
  },
  {
    Header: `Completed`,
    accessor: `completedAt`,
    dbKey: `completedAt`,
    isString: false,
    isNumeric: false,
    isDate: true,
    isBool: false,
    isSortable: false
  },
  {
    Header: `Result`,
    accessor: `result`,
    dbKey: `result`,
    isString: false,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: false
  },
  {
    Header: `Error`,
    accessor: `error`,
    dbKey: `errorMessage`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: false
  },
  {
    Header: `Actions`,
    accessor: `actions`,
    dbKey: `actions`,
    isString: false,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: false
  }
];

export default columns;
